export class AccessoriesProductList {
id: number;
productName: string;
productTitle: string;
categoryNames: string;
categoryIds: string;
companyAddressId: string;
price: number;
priceFormatted: string;
discount: number;
isShowDiscount: boolean;
isShowDiscountValue: string;
isJustAddedValue: string;
isSaleValue: string;
isQuoteValue: string;
isSale: string;
isQuote: string;
features: string;
description: string;
dateFormatted: string;
searchTags:string;
isActive: boolean;
title: string;
length: string;
width: string;
height: string;
weight: string;
isActiveValue: string;
isShippingRequired: boolean;
isShippingRequiredValue: string;
isSelected: boolean;
imageLoader: boolean = true;
fileTitle: string;
productImage: string;
productId: string;
}
export class UpdateAccessoriesProduct {
ProductId: string;
AccessoriesProductIds: string;
}
export class UpdateAccessoriesProductModel {
ProductId: number;
AccessoriesProductIds: string;
}
export class DeleteAccessoriesProductModel {
AccessoriesProductIds :string;                                                                                                   
}